import { useCallback, useState } from 'react'

export const KEEP_MESSAGE_KEY = 'keep-message-on-send'

function loadKeepMessageOnSend(): boolean {
  try {
    return localStorage.getItem(KEEP_MESSAGE_KEY) === 'true'
  } catch {
    return false
  }
}

function saveKeepMessageOnSendInLocalStorage(value: boolean) {
  try {
    localStorage.setItem(KEEP_MESSAGE_KEY, String(value))
  } catch {
    // localStorage unavailable; preference won't persist
  }
}

export const useKeepMessageOnSend = () => {
  const [keepMessageOnSend, setKeepMessageOnSendState] = useState<boolean>(() =>
    loadKeepMessageOnSend()
  )

  const setKeepMessageOnSend = useCallback((value: boolean) => {
    setKeepMessageOnSendState(value)
    saveKeepMessageOnSendInLocalStorage(value)
  }, [])

  return { keepMessageOnSend, setKeepMessageOnSend }
}
